/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Search_PlaceholderInputs */

const en_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search issues...`)
};

const fr_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des incidents...`)
};

const de_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchprobleme...`)
};

const it_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemi di ricerca...`)
};

const ru_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблемы с поиском...`)
};

const es_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemas de búsqueda...`)
};

const zh_cn2_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索问题……`)
};

const ja_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索に関する問題...`)
};

const hi_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज संबंधी समस्याएं...`)
};

const pt_pt2_manual_qc_search_placeholder = /** @type {(inputs: Manual_Qc_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemas de pesquisa...`)
};

/**
* | output |
* | --- |
* | "Search issues..." |
*
* @param {Manual_Qc_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_search_placeholder = /** @type {((inputs?: Manual_Qc_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Search_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_search_placeholder(inputs)
	if (locale === "de") return de_manual_qc_search_placeholder(inputs)
	if (locale === "it") return it_manual_qc_search_placeholder(inputs)
	if (locale === "ru") return ru_manual_qc_search_placeholder(inputs)
	if (locale === "es") return es_manual_qc_search_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_search_placeholder(inputs)
	if (locale === "ja") return ja_manual_qc_search_placeholder(inputs)
	if (locale === "hi") return hi_manual_qc_search_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_search_placeholder(inputs)
	return en_manual_qc_search_placeholder(inputs)
});